import {
  getObject,
  getInt32,
} from "@surya-digital/leo-ts-types";
import { RespondentColumnName, RespondentColumnNameDTO } from "./respondentColumnName";

export interface RespondentColumnDetailsDTO {
  name: RespondentColumnNameDTO;
  index: number;
}

export class RespondentColumnDetails {
  readonly isRespondentColumnDetailsRespondentColumnDetails: boolean = true;

  readonly name: RespondentColumnName;
  readonly index: number;

  static readonly constraints = {
    "index": {
      "minValue": 0,
      "maxValue": 199,
    }
  }

  constructor(
  name: RespondentColumnName, 
  index: number
  ) {
    this.name = name;
    RespondentColumnDetails.validateIndex(index);
    this.index = index;
  }

  static fromDTO(dto: RespondentColumnDetailsDTO): RespondentColumnDetails {
    const name = RespondentColumnName.fromDTO(getObject(dto, "name", InvalidRespondentColumnDetailsNameError));
    const index = getInt32(dto, "index", InvalidRespondentColumnDetailsIndexError);
    return new RespondentColumnDetails(
      name,
      index
    );
  }

  toDTO(): RespondentColumnDetailsDTO {
    const dto: RespondentColumnDetailsDTO = {
        name: this.name.toDTO(),
        index: this.index
    };
    return dto;
  }
  private static validateIndex = (index: number): void => {
    if(index < 0) {
      throw new InvalidRespondentColumnDetailsIndexMinValueError(
        0,
        `Attribute index has value ${index}. Min value is 0.`
      );
    }
    if(index > 199) {
      throw new InvalidRespondentColumnDetailsIndexMaxValueError(
        199,
        `Attribute index has value ${index}. Max value is 199.`
      );
    }
  }
  
}

RespondentColumnDetails.prototype.toString = function toString(): string {
  return `RespondentColumnDetails(name='${this.name}',index='${this.index}')`;
};

export class InvalidRespondentColumnDetailsError extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRespondentColumnDetailsError";
  }
}
export class InvalidRespondentColumnDetailsNameError extends InvalidRespondentColumnDetailsError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRespondentColumnDetailsNameError";
  }
}

export class InvalidRespondentColumnDetailsIndexError extends InvalidRespondentColumnDetailsError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRespondentColumnDetailsIndexError";
  }
}

export class InvalidRespondentColumnDetailsIndexMaxValueError extends InvalidRespondentColumnDetailsIndexError {
  readonly maxValue: number;
  constructor(maxValue: number, message?: string) {
    super(message);
    this.maxValue = maxValue;
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRespondentColumnDetailsIndexMaxValueError";
  }
}

export class InvalidRespondentColumnDetailsIndexMinValueError extends InvalidRespondentColumnDetailsIndexError {
  readonly minValue: number;
  constructor(minValue: number, message?: string) {
    super(message);
    this.minValue = minValue;
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRespondentColumnDetailsIndexMinValueError";
  }
}
